import styles from "./index.css";
import PropTypes from "prop-types";
import { withTranslation } from "../translation";
import { getFilterButtonFocused } from "../../state/modules/layout/selectors";
import { useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  showFilterOverlay,
  showSortOverlay
} from "../../state/modules/layout/actions";
import { hasSearchFacets } from "../../state/modules/search";

const FilterAndSort = ({ formatTranslation }) => {
  const facetsExist = useSelector(hasSearchFacets);
  const dispatch = useDispatch();
  const filterButtonFocused = useSelector(getFilterButtonFocused);
  const filterButtonRef = useRef(null);

  useEffect(() => {
    if (filterButtonFocused) {
      filterButtonRef.current?.focus();
    }
  }, [filterButtonFocused]);

  return (
    <div className={styles.container}>
      <div className={styles.iconWrap}>
        <button
          className={styles.button}
          onClick={() => dispatch(showSortOverlay())}
          data-testid="sort-button"
          disabled={!facetsExist}
        >
          <span className={styles.buttonLabel}>
            {formatTranslation("plp_web_sort_sort")}
          </span>
          <span className={styles.sort} />
        </button>
        <button
          className={styles.button}
          onClick={() => dispatch(showFilterOverlay())}
          ref={filterButtonRef}
          data-testid="filter-button-desktop"
          disabled={!facetsExist}
        >
          <span className={styles.buttonLabel}>
            {formatTranslation("plp_web_refinements_list_filter")}
          </span>
          <span className={styles.filter} />
        </button>
      </div>
    </div>
  );
};

FilterAndSort.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(FilterAndSort);
